import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { supportedLenguage } from '@app/core/helpers/lenguages.helper';
import { TranslateSectionService } from '@app/core/services/translate-section.service';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LanguageConfigService {
    private activatedRoute!: ActivatedRoute;

    public constructor(
        private translateService: TranslateService,
        private router: Router,
        private translateSectionService: TranslateSectionService
    ) {}

    public setActivatedRoute(activatedRoute: ActivatedRoute): this {
        this.activatedRoute = activatedRoute;

        return this;
    }

    public updateLanguageFromUrl(section: string): Observable<any> {
        let langParams: Observable<any> = of({});

        if (this.activatedRoute.parent) {
            langParams = this.activatedRoute.parent.params;
        }

        return langParams.pipe(
            map((params: Params) => {
                if (!params.langCode) {
                    params = {
                        langCode: 'es-AR'
                    };
                }

                let langIsSupported: boolean = supportedLenguage.includes(params.langCode);
                if (!langIsSupported) {
                    this.router.navigate(['/error'], { skipLocationChange: true });

                    return;
                }

                this.translateSectionService.translate(params.langCode, section, this.translateService);

                return params;
            })
        );
    }
}
